// Recipe-book author display (backend Phase 63). A customer-submitted recipe, once approved, is
// published with the customer as author: the API sends their current public name, «هوش‌پز» when
// the account is gone, and an approved profile photo only. The rule matches Android and the PWA
// (plans/recipe-submissions-clients.md, "Author row rule").

export const BRAND_AUTHOR_NAME = 'هوش‌پز';

// Spellings of the brand that never count as a customer's name.
const HOUSE_NAMES = new Set(['هوش‌پز', 'هوش پز', 'هوشپز']);

const authorNameOf = (recipe) => String(recipe?.authorName || '').trim();

export const isHouseName = (name) => HOUSE_NAMES.has(String(name || '').trim());

/**
 * Whether a book recipe shows the customer author row. Never with a blank name. The backend flag
 * `authorIsCustomer` decides when present; an older backend without it falls back to: an author
 * photo (only customer recipes carry one), or a human author whose name is not a house name.
 */
export const isCustomerRecipe = (recipe) => {
    if (!recipe) return false;
    const name = authorNameOf(recipe);
    if (!name) return false;
    if (typeof recipe.authorIsCustomer === 'boolean') return recipe.authorIsCustomer;
    if (recipe.authorAvatarUrl) return true;
    return recipe.authorType === 'human' && !isHouseName(name);
};

/** The name shown on the author row. */
export const customerAuthorName = (recipe) => authorNameOf(recipe);

/** schema.org `author` for the Recipe rich result. */
export const recipeAuthorStructuredData = (recipe, organization) => {
    const name = authorNameOf(recipe);
    // Customer recipes credit the customer; staff-written ones keep crediting their named author,
    // as before Phase 63. A house name (AI, or a deleted customer account) is the Organization.
    const isPerson = (isCustomerRecipe(recipe) || recipe?.authorType === 'human') && name && !isHouseName(name);
    return isPerson ? { '@type': 'Person', name } : organization;
};
